import {
  Mesh,
  Clock,
  Vector3,
  Color,
  Euler,
  SphereGeometry,
  MeshBasicMaterial
} from 'three'
import FireworkComponent from './FireworkComponent'
import BaseHierarchicalObject from '../BaseHierarchicalObject'
import FireworkUtilities from '../FireworkUtilities'
import _ from 'lodash'
export default class Firework extends BaseHierarchicalObject {
  constructor () {
    super()
    this.fuse = 2.0 // seconds
    this.nComponents = 9
    this.exploded = false
    this.explosion_power = 10
    this.timer = new Clock()
    this.lastTime = 0
    this.delta = 0
    this.color = new Color(1.0, 1.0, 0.3)
    this.intensity = 0.5
    this.name = 'firework'
    var geometry = new SphereGeometry(0.2, 8, 8)
    var material = new MeshBasicMaterial()
    material.color = this.color
    this.oShell = new Mesh(geometry, material)
    this.velocity = new Vector3(0, 0, 0)
    this.acceleration = new Vector3(0, -9.8, 0)
    this.add(this.oShell)
  }
  checkValid () {
    if (this.exploded && this.children.length === 0) { this._parent.removeChild(this) }
  }
  update (timeStamp) {
    super.update(timeStamp)
    this.checkValid()
    if (this.timer.getElapsedTime() > this.fuse && !this.exploded) {
      this.explode()
    }
    if (this.timer.getElapsedTime() > this.fuse) { return }
    var translate = this.velocity.clone().multiplyScalar(this.delta)
    var dV = this.acceleration.clone().multiplyScalar(this.delta)
    // console.log(translate)
    this.velocity.add(dV)
    this.oShell.position.add(translate)
  }
  launch () {
    // this.mainClock.start();
  }
  lookAtPosition () {
    return this.oShell.position
  }
  getFireworkData () {
    if (this.oShell != null) {
      return {
        position: this.oShell.position,
        color: this.color,
        intensity: this.intensity
      }
    }
  }
  explode2 () {
    var rotation = new Euler(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI)
    for (let i = 0; i < this.subcomponentTemplate.length; i += 1) {
      let sub = this.subcomponentTemplate[i]
      var subcomponent = new FireworkComponent(new Color(sub['color']))

      subcomponent.setPosition(this.oShell.position)
      
      var star = FireworkUtilities.add3dNoise(new Vector3(this.explosion_power * sub['vector'][0], -1 * this.explosion_power * sub['vector'][1], 0), 0.7, 0.7, 0.7)
      star.applyEuler(rotation)
      subcomponent.setVelocity(star.add(this.velocity))
      this.addChild(subcomponent)
    }
    this.exploded = true
    this.remove(this.oShell)
    this.oShell = null
  }
  explode () {
    if (this.exploded) {
      return
    }
    if (this.subcomponentTemplate != null) {
      this.explode2()
      return
    }
    var starPoints = [
      [50.000, 70.000],
      [79.389, 90.451],
      [69.021, 56.180],
      [97.553, 34.549],
      [61.756, 33.820],
      [50.000, 0.000],
      [38.244, 33.820],
      [2.447, 34.549],
      [30.979, 56.180],
      [20.611, 90.451]
    ]
    var colors = [new Color(1.0, 0, 0), new Color(1.0, 1.0, 0.0), new Color(0.0, 1.0, 0.0)]
    var rotation = new Euler(Math.random() * Math.PI * 2, Math.random() * Math.PI * 2, Math.random() * Math.PI * 2)
    FireworkUtilities.normalize2DPoints(starPoints)
    var color = _.sample(colors)
    for (var i = 0; i < starPoints.length; i++) {
      var subcomponent = new FireworkComponent(color)

      subcomponent.setPosition(this.oShell.position)
      var star = FireworkUtilities.add3dNoise(new Vector3(this.explosion_power * starPoints[i][0], -1 * this.explosion_power * starPoints[i][1], 0), 0.7, 0.7, 0.7)
      star.applyEuler(rotation)
      subcomponent.setVelocity(star.add(this.velocity))
      this.addChild(subcomponent)
    }
    this.exploded = true
    this.remove(this.oShell)
    this.oShell = null
    // this.add(new FireworkComponent())
    // for(var i = 0; i < this.nComponents; i++)
    // {
    //   var subcomponent = new FireworkComponent()

    //   subcomponent.setPosition(this.oShell.position)
    //   var randomVelocity=new Vector3(this.explosion_power*(Math.random()-0.5),this.explosion_power*(Math.random()-0.5),this.explosion_power*(Math.random()-0.5))
    //   subcomponent.setVelocity(randomVelocity.add(this.velocity))
    //   this.addChild(subcomponent)
    // }
  }
  setVelocity (inVelocity) {
    this.velocity.copy(inVelocity)
  }
  setPosition (inPosition) {
    this.oShell.position.copy(inPosition)
  }
  setSubcomponentTemplate (template) {
    this.subcomponentTemplate = template
  }
}
